import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import "./style.scss";
import { Helmet } from "react-helmet";
import { learnersCornerList } from './actions';
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import { getRouting, getLang } from '../../../../utils/common';

const LearnersCorner = (props) => {
  learnersCornerListData
  const { learnersCornerList, learnersCornerListData } = props;
  const [cornerList, setCornerList] = useState();
  const [metaData, setMetaData] = useState("");


  const handleExploreReadmore = async (e, value) => {
    var v = document.getElementById('moretext' + value);
    v.classList.add('autoHeight1');
  };
  const handleCollapseeReadLess = async (e, value) => {
    var v = document.getElementById('moretext' + value);
    v.classList.remove(
      'autoHeight1',
    );
  };

  useEffect(() => {
    !(learnersCornerListData && learnersCornerListData.cornerList) && learnersCornerList();
  }, []);
  useEffect(() => {
    if (learnersCornerListData && learnersCornerListData.cornerList && learnersCornerListData.cornerList.learnersCornerScreens
    ) {
      setCornerList(learnersCornerListData.cornerList.learnersCornerScreens);
    }
    if (learnersCornerListData && learnersCornerListData.cornerList && learnersCornerListData.cornerList.meta
      ) {
        setMetaData(learnersCornerListData.cornerList.meta);
      }
  }, [learnersCornerListData]);

  return (
    <div className="wrapper">
     
      {metaData && metaData !== null && <Helmet>
        <title>{metaData.title ? metaData.title : ""}</title>
        <meta name="description" content={metaData.description ? metaData.description : ""} />
        <meta name="keywords" content={metaData.keywords ? metaData.keywords : ""} />
        <meta property="og:title" content={metaData.og_title ? metaData.og_title : ""} />
        <meta property="og:description" content={metaData.og_description ? metaData.og_description : ""} />
        <meta property="og:image" content={metaData.og_image ? metaData.og_image : ""} />
        <meta property="og:url" content={metaData.og_url ? metaData.og_url : ""} />
      </Helmet>}

      <section className="aboutHead">
        <div className="container">
          <div className="d-flex">
            <h1 className="me-auto">
              <span>Learners’ </span> Corner
            </h1>
            <nav
              aria-label="breadcrumb"
              className="align-self-center breadCrumbCust d-md-inlin"
            >
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li
                  className="breadcrumb-item active breadcolor"
                  aria-current="page"
                >
                  Learners’ Corner
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>

      <section className="learnCards">
        <div className="container">
          <div className="row">
            {cornerList && cornerList.length > 0 && cornerList.map((list, index) => (
              <div className="col-md-4">
                <div id={`card${index}`} className="card" key="index">
                  <div className="cardHead d-flex">
                    <div className="align-self-center">
                      <img src={list && list.attributes && list.attributes.class} alt="cardimg" />
                    </div>
                    <div className="ms-3 align-self-center">
                      <p>{list && list.linkName}</p>
                      <p className="subheading">{list && list.linkDescription}</p>
                    </div>
                  </div>
                  <div className="cardFooter">
                    <div id={`moretext${index}`} className="moretext ps-0 mb-2">
                      <div className="accordion" id={`accordionHome${index}`} >
                        <div className="accordion-item border-0">
                          <div>
                            {list && list.childrens.length > 0 && list.childrens.map((childList) => (
                              <a className="cardmain">
                                  <a href={childList.routeConstant} >
                                <div className="d-flex justify-content-between w-100 borderbottom">
                                    <p>{childList && childList.linkName}</p>
                                    <img
                                      src="/images/New/red-right-arrow.png"
                                      alt="arrowimg"
                                    />
                                </div>
                                </a>
                              </a>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                    {list && list.linkName === 'Podcast' ?
                      <a
                        href={list.routeConstant}
                        className=" readMore1 position-relative"
                      >
                        <p className="more p_primary">Listen Here</p>
                      </a> : ''
                    }

                    {list && list.linkName === 'Videos' ?
                      <a
                        href={list.routeConstant}
                        className=" readMore1 position-relative"
                      >
                        <p className="more p_primary">Watch Here</p>
                      </a> : ''
                    }

                    {list && list.linkName === 'The Reading Room' ?
                      <a
                        href={list.routeConstant}
                        className=" readMore1 position-relative"
                      >
                        <p className="more p_primary">Read Here</p>
                      </a> : ''
                    }

                    {list && list.linkName === 'Quiz' ?
                      <a
                        href={list.linkUrl}
                        className=" readMore1 position-relative"
                      >
                        <p className="more p_primary">Read Here</p>
                      </a> : ''
                    }

                    {list.linkName !== 'Videos' && list.linkName !== 'Podcast' && list.linkName !== 'The Reading Room' && list.linkName !== 'Quiz' ?
                      <>
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => handleExploreReadmore(e, index)}
                          className="lessMoreArrow1 readMore1 position-relative"
                        >
                          <p className="more p_primary">Show less</p>
                        </a>
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => handleCollapseeReadLess(e, index)}
                          className="lessMoreArrow1 readLess1 position-relative"
                        >
                          <p className="less p_primary">View Details</p>
                        </a>
                      </>
                      : ''
                    }
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

const mapStateToProps = (state) => ({
  learnersCornerListData: state.LearnsCorners,
})

const mapDispatchToProps = (dispatch) => ({
  learnersCornerList: bindActionCreators(learnersCornerList, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(LearnersCorner);
